import { render, staticRenderFns } from "./CurrentProjects.vue?vue&type=template&id=cc7626b6&"
import script from "./CurrentProjects.vue?vue&type=script&lang=ts&"
export * from "./CurrentProjects.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentProjects.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports